module.exports = __webpack_public_path__ + "static/media/h-slider-3.742f8c4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h-slider-3.jpg
// module id = 1146
// module chunks = 33